export const isValidCustomer = (userAttributes: Record<string, any>): boolean =>
  !!userAttributes.life_started_flow;
